import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { type ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import { ApiClientProvider } from '@/api/api-context';
import { Announcer } from '@/components/announcer';
import { AppErrorBoundary } from '@/components/error-pages';
import { i18n } from '@/i18n';

export interface AppProvidersProps {
  queryClient: QueryClient;
  children: ReactNode;
}

/**
 * Every app-wide provider, in dependency order. Tests use the same stack (src/test/render.tsx). The theme and the
 * toasts are orno's own (orno-theme.js and Orno.toast); failures are also said through the one assertive live
 * region, the Announcer.
 */
export function AppProviders({ queryClient, children }: AppProvidersProps) {
  return (
    <AppErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <ApiClientProvider>
            {children}
            <Announcer />
          </ApiClientProvider>
        </QueryClientProvider>
      </I18nextProvider>
    </AppErrorBoundary>
  );
}
